import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialogRef } from '@angular/material';

import { SessionStorageService, LoginService } from '../../core/index.service';
import { ProfileInfo } from '../../core/index.model';
import { UserRole } from '../../core/enumtype';

@Component({
    selector: 'shared-profileinfomodal',
    templateUrl: './profileinfo.component.html',
    styleUrls: ['./profileinfo.component.css']
})
export class ProfileInfoComponent implements OnInit {

    profileInfo: ProfileInfo;
    currentPage: string;

    constructor(
        private router: Router,
        private storageService: SessionStorageService,
        private loginService: LoginService,
        public dialogRef: MatDialogRef<ProfileInfoComponent>
    ) { }

    ngOnInit() {
        this.currentPage = window.location.href;
        if (this.storageService.getUserRole() === UserRole.Citizen) {
            this.editProfile(this.storageService.getUserID());
        } 
    }

    editProfile(citizenID: string) {
        this.loginService
            .editProfile(citizenID)
            .then(response => {
                if (response !== undefined) {
                    this.profileInfo = response;
                }
            }
            )
            .catch(err => {
                
            });
    }

    cmdGo(strPage: string) {
        if (this.storageService.getUserRole() === UserRole.Citizen) {
            this.dialogRef.close();
            let link = (strPage === 'profile') ? ['citizen/myaccount'] : ['citizen/resetpassword/' + this.storageService.getUserID()];
            this.router.navigate(link);
        }
    }

    closeModal(): void {
        this.dialogRef.close();
    }

    logOut() {
        this.storageService.logOut();
        this.dialogRef.close();
        let link = ['home'];
        this.router.navigate(link);
        this.storageService.removeRequestFormUrl();
    }


}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/login/profileinfo.component.ts